import { TIMMER } from './constants';

export function tempoTemporizador(values) {
  return {
    type: TIMMER,
    values,
  };
}
